import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'store/hooks';
import EmptyState from './EmptyState';
import Loader from './Loader';

type DisplayLoadingOrNotResultProps = {
  items: any[] | null;
};
const DisplayLoadingOrNotResult = (props: DisplayLoadingOrNotResultProps) => {
  const { items } = props;
  const [rendered, setRendered] = useState(false);
  const loadings = useSelector((state) => state.loadings);
  const [t] = useTranslation();
  useEffect(() => {
    if (items && items?.length === 0) setRendered(true);
    else setRendered(false);
    return () => setRendered(false);
  }, [items]);

  if (loadings.orders || loadings.api) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <Loader />
      </Box>
    );
  }

  if (rendered) {
    return <EmptyState title={t('Nothing')} />;
  }
  return <> </>;
};
export default DisplayLoadingOrNotResult;
